import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import { events } from "@/mocks/events";

export default function EventsSection() {
  const recentEvents = events.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          eyebrow="争议事件追踪"
          title="正在跟踪的争议事件"
          description="每一起事件都建立独立档案，公开立案时间、争议焦点与核查进度，任何人都可以回看事件走向。"
        />
        <Link
          to="/events"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-medium border border-foreground-300 text-foreground-900 hover:bg-background-50 transition-colors whitespace-nowrap shrink-0"
        >
          查看全部事件
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {recentEvents.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </div>
    </section>
  );
}